import { createAction } from "@reduxjs/toolkit";

export const sendOtpAction = createAction("sendOtp", (Request: any,onSuccess?:Function, onError?:Function) => ({
    payload: { Request,onSuccess,onError },
}));
export const verifyOtpAction = createAction("verifyOtp", (Request: any,mobile:any, onSuccess?:Function, onError?:Function) => ({
    payload: { Request,mobile, onSuccess,onError },
}));
export const createBookingAction = createAction("createBooking", (Request: any, history:any, onSuccess?:Function, onError?:Function) => ({
    payload: { Request,history,onSuccess,onError },
}));
export const createHomeCollectionAction = createAction("createhomeCollection", (Request: any, history:any, onSuccess?:Function, onError?:Function) => ({
    payload: { Request,history,onSuccess,onError },
}));
export const updateBookingAction = createAction("updateBooking", (Request: any, history:any, onSuccess?:Function, onError?:Function) => ({
    payload: { Request,history,onSuccess,onError },
}));
export const availableSlotAction = createAction("availableSlot", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess, onError},
}));
export const bookingValidationAction = createAction("bookingValidation", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess, onError },
}));
export const storeCartDataAction = createAction("storeCartData", (Request: any) => ({
    payload: {Request },
}));
